@if (selectedImage) {
  <div class="image-area ws-product-detail__media">
    @if (ui.isMobile()) {
      <div class="swipe" #swipeImages>
        <div class="swipe-wrap">
          @for (image of images; track image) {
            <div>
              <product-img
                [image]="image"
                [alt]="alt"
                (click)="showSelectedImageWithSwipe()">
              </product-img>
            </div>
          }
        </div>
      </div>
    }

    @if (!ui.isMobile()) {
      <product-img
        class="pointer"
        [image]="selectedImage"
        [alt]="alt"
        (click)="showImage(selectedImage)">
      </product-img>
    }

    <ng-content select="[productImgOverlay]"></ng-content>
  </div>

  @if (images?.length > 1) {
    <div class="gallery-wrap clearfix d-flex flex-wrap justify-content-center">
      @for (image of images; track image) {
        <div class="gallery-item ws-product-detail__thumb"
             [class.selected-item]="selectedImage === image"
             [class.ws-product-detail__thumb--selected]="selectedImage === image"
             (click)="galleryItemClick(image)">
          <img src="{{ image | multiUrlImage : 'small' : '' }}" [alt]="alt">
        </div>
      }
    </div>
  }
}
